export function referrerGuard(allowedRefPath: string, redirectTo : string = '/') {
  return defineNuxtRouteMiddleware((to, from) => {
    const headers = useRequestHeaders();
    const referer = import.meta.client ? document.referrer : headers['referer'] || '';

    if (!referer.includes(allowedRefPath)) {
      return navigateTo(redirectTo);
    }
  });
}